export class RoutingData {
}

export module RoutingData {
  export class Extras {
    static readonly REDIRECT_TO = 'redirect-to';
  }
}
